import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchProductBrands } from '../../../../actions/product/productBrandList'
import { AppState } from '../../../../reducers'
import { FiltersBar, FilterTextField } from '../../../Utils/Filters/Filter'
import { useTranslation } from 'react-i18next'
import { ProductBrandListState } from '../../../../reducers/product/productBrandList'
import { Button, Stack } from '@mui/material'
import ProductBrand from '../../../../models/ProductBrand'
import ProductBrands from '../ProductBrands'

interface Props {
  fullInfo?: boolean
  productBrandList: ProductBrandListState
}

const ProductBrandList: React.FC<Props> = ({ productBrandList }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('product')
  const [edit,] = useState(false)

  useEffect(() => {
    dispatch(fetchProductBrands(history.location.search))
  }, [dispatch, history.location.search, edit])


  const linkToProductBrandEdit = (productBrand: ProductBrand) => {
    const editUrl = `/admin/productBrands/update/${productBrand.id}`
    history.push(editUrl, { update: edit })
  }

  return (
    <div>
      <FiltersBar>
        <FilterTextField style={{marginRight:"10px"}} name="code" label={t("code")} />
        <FilterTextField style={{maxWidth:"400px", width:"400px", marginRight:"10px"}} name="description" label={t("description")} />
      </FiltersBar>
      <ProductBrands
        rows={(productBrandList.productBrands || []).map(s => ({ data: s }))}
        loading={productBrandList.isFetching}
        pagination={productBrandList.pagination || undefined}
        onClickInfo={linkToProductBrandEdit}
      />

      <Stack display="flex" flexDirection='row' justifyContent="space-between" padding="10px">
        <Button aria-label="back" size='large' style={{ textTransform: 'none' }}  onClick={() => history.push('/admin/productBrands/create', { title: t('create') })}>
        {`${t('create')}${t('brand')}`}
        </Button>
      </Stack>
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  productBrandList: state.productBrandList,
})

export default connect(mapStateToProps, null)(ProductBrandList)